import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

function capitalise(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  return string
}

export const Card = ({
  title,
  titleCenter,
  subtitle,
  subtitleCenter,
  children,
  typeName,
  attention,
  style,
}) => (
  <div
    className={`${midas.card} ${typeName &&
      midas[`card${capitalise(typeName)}`]} ${attention &&
      midas.cardAttention}`}
    style={{ ...style, overflow: 'hidden' }}
  >
    <span>{titleCenter}</span>
    {title && (
      <div className={midas.cardHeader}>
        <div
          className={`${midas.cardTitle} ${titleCenter && midas.textCenter}`}
        >
          {title}
        </div>
        <div
          className={`${midas.cardSubtitle} ${
            subtitleCenter ? midas.textCenter : ''
          }`}
        >
          {subtitle}
        </div>
      </div>
    )}
    <div className={midas.cardBody}>{children}</div>
  </div>
)

Card.defaultProps = {
  title: null,
  subtitle: null,
  titleCenter: false,
  subtitleCenter: false,
  typeName: null,
  attention: false,
  style: null,
}

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.any.isRequired,
  subtitle: PropTypes.string,
  titleCenter: PropTypes.bool,
  subtitleCenter: PropTypes.bool,
  typeName: PropTypes.string,
  attention: PropTypes.bool,
  style: PropTypes.object,
}
